<div class="search-page">
  <!-- =========================================================
       Search hero
  ========================================================== -->

  <section class="search-hero">
    <div class="search-hero__background" aria-hidden="true">
      <span class="search-orb search-orb--one"></span>
      <span class="search-orb search-orb--two"></span>
      <span class="search-grid-pattern"></span>
    </div>

    <div class="search-hero__content">
      <div class="search-hero__copy">
        <span class="hero-kicker">Find your next appointment</span>

        <h1>
          Discover local
          <span>beauty & wellness.</span>
        </h1>

        <p>
          Search salons, barbers, spas, services, and treatments near you and
          book the experience that fits.
        </p>
      </div>

      <div class="search-summary">
        <span>Results</span>

        <strong>
          {{ shownSalons.length }}
        </strong>

        <small>matching businesses</small>
      </div>
    </div>

    <!-- =======================================================
         Search controls
    ======================================================== -->

    <div class="search-panel">
      <div class="search-panel__main">
        <!-- Service -->

        <div
          class="search-field search-field--service"
          (click)="$event.stopPropagation()"
        >
          <span class="search-field__label">Service or salon</span>

          <div class="search-control-shell">
            <glo-control
              icon="search"
              name="serviceSearch"
              [(value)]="serviceQuery"
              (valueChange)="onServiceQueryInput($event)"
              placeholder="Service or business"
              classes="bg-gray-50"
            ></glo-control>
          </div>

          <div
            *ngIf="showServiceSuggestions && serviceSuggestions.length"
            class="suggestions"
          >
            <button
              type="button"
              *ngFor="let suggestion of serviceSuggestions"
              class="suggestion-item"
              (click)="selectServiceSuggestion(suggestion)"
            >
              <div class="suggestion-item__main">
                <div
                  class="suggestion-icon"
                  [class.suggestion-icon--salon]="suggestion.kind === 'salon'"
                  [class.suggestion-icon--service]="
                    suggestion.kind === 'service'
                  "
                  [class.suggestion-icon--type]="suggestion.kind === 'type'"
                >
                  @switch (suggestion.kind) {
                    @case ("salon") {
                      <span>⌂</span>
                    }

                    @case ("service") {
                      <span>✦</span>
                    }

                    @case ("type") {
                      <span>◆</span>
                    }

                    @default {
                      <span>#</span>
                    }
                  }
                </div>

                <span>
                  {{ suggestion.label }}
                </span>
              </div>

              <span class="suggestion-kind">
                {{ suggestion.kind }}
              </span>
            </button>
          </div>
        </div>

        <!-- Location -->

        <div class="search-field">
          <span class="search-field__label">Location</span>

          <div class="search-control-shell search-control-shell--location">
            <app-google-address
              name="locationSearch"
              label=""
              [placeholder]="locationPlaceholder"
              [(ngModel)]="locationQuery"
              (ngModelChange)="onLocationQueryInput()"
              (placeSelected)="onLocationPlaceSelected($event)"
            >
            </app-google-address>
          </div>
        </div>

        <!-- Cost -->

        <div class="search-field search-field--cost">
          <span class="search-field__label">Cost</span>

          <div class="search-control-shell search-control-shell--cost">
            <glo-control
              type="select"
              name="costSearch"
              [options]="costOptions"
              [showKey]="'name'"
              [valueKey]="'id'"
              [placeholder]="'Any price'"
              [(value)]="selectedCost"
              classes="bg-gray-50"
            ></glo-control>
          </div>
        </div>

        <!-- Date + Time -->

        <div class="search-field search-field--datetime">
          <span class="search-field__label">Date & time</span>

          <div class="date-timerange-control">
            <glo-date-control
              class="flex flex-1"
              [value]="selectedSearchDate"
              (dateChange)="onSearchDateChange($event)"
            ></glo-date-control>

            <glo-timepicker
              [startTime]="selectedSearchStartTime || '09:00'"
              [endTime]="selectedSearchEndTime || '12:00'"
              (timeChange)="onSearchTimeChange($event)"
            ></glo-timepicker>
          </div>
        </div>
      </div>

      <button
        type="button"
        class="primary-cta search-primary-cta"
        (click)="searchSalons()"
      >
        Discover now
      </button>
    </div>
  </section>

  <!-- =========================================================
       Results heading
  ========================================================== -->

  <section class="results-heading">
    <div>
      <span class="section-kicker">Explore</span>

      <h2>Salons matching your search.</h2>

      <p>
        Browse businesses, compare services, and find the right place for your
        next appointment.
      </p>

      <div
        *ngIf="availabilitySearchActive && availabilitySummary"
        class="availability-search-summary"
      >
        <span class="availability-dot"></span>
        Available {{ availabilitySummary }}
      </div>
    </div>

    <div class="results-heading__stats">
      <div>
        <strong>
          {{ shownSalons.length }}
        </strong>

        <span>results</span>
      </div>
    </div>
  </section>

  <!-- =========================================================
       Loading
  ========================================================== -->

  <div *ngIf="loading" class="search-state">
    <div class="search-spinner"></div>

    <strong>Finding salons</strong>

    <span>Searching available businesses near you...</span>
  </div>

  <!-- =========================================================
       Error
  ========================================================== -->

  <div *ngIf="!loading && error" class="search-state search-state--error">
    <strong>Unable to load salons</strong>

    <span>
      {{ error }}
    </span>

    <button type="button" (click)="loadSalons()">Try again</button>
  </div>

  <!-- =========================================================
       Results
  ========================================================== -->

  <section *ngIf="!loading && !error" class="results-layout">
    <div class="results-list">
      <div *ngIf="shownSalons.length === 0" class="no-results">
        <div class="no-results__icon">✦</div>

        <h3>No salons found</h3>

        <p *ngIf="!availabilitySearchActive">
          Try another service, category, or location.
        </p>

        <p *ngIf="availabilitySearchActive">
          No matching businesses have availability for the selected date and
          time. Try another time, service, or location.
        </p>

        <button type="button" (click)="clearSearch()">Clear search</button>
      </div>

      <ng-container
        *ngFor="
          let salon of shownSalons
            | slice: (currentPage - 1) * pageSize : currentPage * pageSize
        "
      >
        <a
          class="salon-card"
          [routerLink]="['/customer/salon', salon.salon_id]"
        >
          <div class="salon-card__image">
            <img
              [src]="
                salon.image ||
                salon.image_url ||
                assetUrl + 'img/salon-details3.png'
              "
              [alt]="salon.name"
            />

            <div class="salon-card__overlay"></div>

            <span *ngIf="salon.business_type" class="salon-card__type">
              {{ salon.business_type }}
            </span>

            <span class="salon-card__view">
              View salon
              <span>→</span>
            </span>
          </div>

          <div class="salon-card__content">
            <div class="salon-card__heading">
              <div>
                <span class="salon-card__eyebrow">Available to book</span>

                <h3>
                  {{ salon.name }}
                </h3>
              </div>

              <div class="salon-card__rating">
                <img [src]="assetUrl + 'icons/star-yellow.svg'" alt="" />

                <strong>
                  {{ salon.rating || "—" }}
                </strong>
              </div>
            </div>

            <div class="salon-card__meta">
              <div class="salon-meta-row">
                <img [src]="assetUrl + 'icons/star.svg'" alt="" />

                <span>
                  {{ salon.review_count || 0 }}
                  reviews
                </span>
              </div>

              <div class="salon-meta-divider"></div>

              <div class="salon-meta-row">
                <img [src]="assetUrl + 'icons/marker.svg'" alt="" />

                <span>
                  {{ salon.distance || salon.city || "Nearby" }}
                </span>
              </div>
            </div>

            <p *ngIf="salon.address" class="salon-address">
              {{ salon.address }}

              <ng-container *ngIf="salon.city">
                · {{ salon.city }}
              </ng-container>
            </p>

            <div *ngIf="salon.tags?.length" class="salon-tags">
              <glo-tag
                *ngFor="let tag of salon.tags"
                [text]="tag"
                state="default"
                [showIcon]="false"
              >
              </glo-tag>
            </div>

            <div class="salon-card__footer">
              <div class="salon-card__availability">
                <span class="availability-dot"></span>

                <span *ngIf="!availabilitySearchActive">
                  Booking available
                </span>

                <span *ngIf="availabilitySearchActive">
                  Available
                  {{ formatTimeForDisplay(lastAvailabilityStartTime) }} –
                  {{ formatTimeForDisplay(lastAvailabilityEndTime) }}
                </span>
              </div>

              <span class="salon-card__cta">
                Explore services
                <span>→</span>
              </span>
            </div>
          </div>
        </a>
      </ng-container>

      <div *ngIf="shownSalons.length > 0" class="pagination-shell">
        <glo-pagination
          [totalItems]="shownSalons.length"
          [(currentPage)]="currentPage"
          [(itemsPerPage)]="pageSize"
          [itemsPerPageOptions]="[8, 16, 24, 32]"
          (currentPageChange)="onPageChange($event)"
        >
        </glo-pagination>
      </div>
    </div>

    <aside class="map-panel">
      <div class="map-panel__header">
        <div>
          <span class="section-kicker">Map</span>

          <h3>Explore nearby.</h3>
        </div>

        <span class="map-count">
          {{ mapMarkers.length }}
          locations
        </span>
      </div>

      <div class="map-panel__map">
        <glo-google-map
          [center]="{
            lat: latitude,
            lng: longitude,
          }"
          [zoom]="zoom"
          [markers]="mapMarkers"
          [bounds]="bounds"
        >
        </glo-google-map>
      </div>

      <div class="map-panel__footer">
        <span *ngIf="!availabilitySearchActive">
          Results update automatically as you search.
        </span>

        <span *ngIf="availabilitySearchActive">
          Showing businesses available for your selected appointment time.
        </span>
      </div>
    </aside>
  </section>
</div>
